module.exports = __webpack_public_path__ + "static/media/speakers_logos_PropTech.21a963f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_PropTech.jpg
// module id = 276
// module chunks = 0